export const supportedLocales = {
    de: 'Deutsch',
    en: 'English'
};

export const fallbackLocale = 'de';
